import moment from 'moment';
import useSetExport from '@components/export/useSetExport';

export const useSummaryTableExport = ({ alerts, columns, interval, sortBy }) => {
  const headers = columns.map(({ title, dataKey }) => {
    return { title, key: dataKey, type: null };
  });

  // Export data as-is - no sorting needed in export hook
  // Data comes pre-sorted from backend (DPI/App) or gets sorted by table component (Video/Ad)
  const data = alerts;

  const intervalStr = `(${moment(interval.from).format()} - ${moment(interval.to).format()})`;

  useSetExport({
    pageKey: 'ai-alerts-summary',
    sectionKey: 'ai-alerts-summary',
    widgetKey: 'ai-alerts-summary',
    widgetInfo: {
      title: `AI Alerts Summary ${intervalStr} Export`,
    },
    data,
    headers,
  });
};
